import { render } from "./ReviewContainer.vue?vue&type=template&id=36ddbc77&scoped=true"
import script from "./ReviewContainer.vue?vue&type=script&lang=js"
export * from "./ReviewContainer.vue?vue&type=script&lang=js"

import "./ReviewContainer.vue?vue&type=style&index=0&id=36ddbc77&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ddbc77"]])

export default __exports__